<template>
  <a-modal
    :title="title"
    :width="780"
    :visible="visible"
    :confirmLoading="loading"
    @ok="ok"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" v-bind="formLayout">
        <a-row :gutter="[16,16]" v-if="productValueList.length === 0 && false">
          <a-col :span="24">
            <a-form-item label="名称">
              <a-input v-decorator="['name', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="名称"/>
            </a-form-item>
            <a-form-item label="符号">
              <a-select
                v-decorator="[
                  'symbol',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption">
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.trade_value_compare_symbol">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="标准值">
              <a-input-number :precision="4" v-decorator="['standard_value', {rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="标准值"/>
            </a-form-item>
          </a-col>
        </a-row>
        <div v-else>
          <a-table
            bordered
            :data-source="productValueList"
            :columns="productColumns"
            :pagination="false"
            key="key">
            <template slot="name" slot-scope="text, record">
              <div v-if="productNameList.includes(text)">
                <span>{{ text }}</span>
              </div>
              <div v-else>
                <a-input :default-value="text" placeholder="名称" @change="e => handleItemChange(e.target.value, record.key, 'name')"/>
              </div>
            </template>
            <template slot="symbol" slot-scope="text, record">
              <a-select
                placeholder="选择"
                show-search
                :default-value="text + ''"
                @change="e => handleItemChange(e, record.key, 'symbol')"
                option-filter-prop="children"
                :filter-option="filterOption">
                <a-select-option :key="key" :value="key" v-for="(val, key) in dictionaries.trade_value_compare_symbol">{{ val }}</a-select-option>
              </a-select>
            </template>
            <template slot="standard_value" slot-scope="text, record">
              <a-input-number :default-value="text" :precision="4" placeholder="标准值" @change="e => handleItemChange(e, record.key, 'standard_value')" />
            </template>
            <template slot="action" slot-scope="text, record">
              <a-popconfirm
                title="确定删除?"
                @confirm="() => onProductDelete(record)"
              >
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </template>
            <template slot="footer">
              <a-button icon="plus" @click="addItem">添加</a-button>
            </template>
          </a-table>
        </div>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import cloneDeep from 'lodash.clonedeep'

// 表单字段
const fields = ['id', 'name', 'symbol', 'standard_value']
export default {
  components: {},
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      }
    }
    return {
      form: this.$form.createForm(this),
      dictionaries: this.$Dictionaries,
      defaultSymbol: 1,
      productValueList: [],
      productNameList: [],
      productColumns: [
        {
          title: '名称',
          dataIndex: 'name',
          width: 150,
          ellipsis: true,
          scopedSlots: { customRender: 'name' }
        },
        {
          title: '符号',
          dataIndex: 'symbol',
          width: 160,
          ellipsis: true,
          scopedSlots: { customRender: 'symbol' }
        },
        {
          title: '值',
          dataIndex: 'standard_value',
          width: 160,
          ellipsis: true,
          scopedSlots: { customRender: 'standard_value' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  created () {
    console.log('custom modal created', this.model)
    // 防止表单未注册
    fields.forEach(v => this.form.getFieldDecorator(v))
    // 当 model 发生改变时，为表单设置值
    this.$watch('model', () => {
      this.model && this.form.setFieldsValue(pick(this.model, fields))
    })
  },
  mounted () {
    this.loadDefaultData()
  },
  computed: {
    title () {
      if (this.model !== undefined && this.model['name'] !== undefined) {
        return '修改' + this.model['name']
      } else {
        return '新建'
      }
    }
  },
  methods: {
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    onProductDelete (item) {
      this.productValueList = this.productValueList.filter(product => {
        return product.name !== item.name
      })
    },
    loadDefaultData () {
      const ppList = this.model['product_parameter_list']
      if (ppList === undefined || ppList.length === 0) {
        if (this.dictionaries.trade_product_default_value[this.model['name']] !== undefined) {
          this.productNameList = (this.dictionaries.trade_product_default_value[this.model['name']]).split(',')
          if (this.productNameList.length > 0) {
            const current_date = new Date()
            this.productValueList = this.productNameList.map(item => {
              return {
                name: item,
                symbol: '',
                standard_value: undefined,
                key: current_date.getHours() + '' + current_date.getMinutes() + '' + current_date.getSeconds() + Math.floor(Math.random() * 100000)
              }
            })
          } else {
            this.addItem()
          }
        } else {
          this.addItem()
        }
      } else {
        const current_date = new Date()
        this.productValueList = ppList.map(item => {
          item['key'] = item.id === undefined ? (current_date.getHours() + '' + current_date.getMinutes() + '' + current_date.getSeconds() + '' + Math.floor(Math.random() * 100000)) : item.id
          return cloneDeep(item)
        })
      }
    },
    addItem () {
      const current_date = new Date()
      this.productValueList.push({
        name: '',
        symbol: '',
        standard_value: undefined,
        key: current_date.getHours() + '' + current_date.getMinutes() + '' + current_date.getSeconds()
      })
    },
    handleItemChange (value, key, column) {
      const newData = [...this.productValueList]
      const target = newData.find(item => key === item.key)
      if (target) {
        target[column] = value
        this.productValueList = newData
      }
    },
    ok () {
      const pvList = this.productValueList.filter(item => {
        return (item.name !== undefined && item.name !== '') && (item.symbol !== undefined && item.symbol !== '') && (item.standard_value !== undefined && item.standard_value !== null)
      })
      if (pvList.length === this.productValueList.length) {
        this.$emit('ok', pvList)
      } else {
        this.$message.warning('填写全部参数')
      }
    }
  }
}
</script>
